import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  .small-container {
    display: flex;
    flex: 1;
    min-width: 350px;
  }

  .large-container {
    display: flex;
    flex: 2;
    min-width: 350px;
  }
`;
